module.exports = __webpack_public_path__ + "static/media/button_bg.3424eab5.png";